import { render, staticRenderFns } from "./NetworkLeaders.vue?vue&type=template&id=0031434b"
import script from "./NetworkLeaders.vue?vue&type=script&lang=js"
export * from "./NetworkLeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports